import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-banner-footer-pages',
  templateUrl: './banner-footer-pages.component.html',
  styleUrls: ['./banner-footer-pages.component.css'],
})
export class BannerFooterPagesComponent {
  @Input() title: string = '';
  @Input() customClasses: string = '';

}
